module.exports = __webpack_public_path__ + "img/JaniceSommerville.b921de72.png";